import { IFDGState } from "@/core/interfaces/state/fdgState.interface";

const fdgState: IFDGState = {
  fdgList: [],
  isFetchingFDGList: false,
  fdgDetail: null,
  isFetchingFDGDetail: false,
  fdgBookingDetail: null,
  isFetchingFDGBookingDetail: false,
  isInitiatingFDGBooking: false,
  isConfirmFDGBooking: false,
  isConfirmFDGBookingWithoutTravelerDetails: false,
  isOTPVerificationInProgress: false,
  isGroupBookingPassengersFetching: false,
  bookingFormOTPReference: "",
  isGroupFlightsPaynowLoading: false,
  passengers: [],
  isGroupFlightsCancelLoading: false,
};

export default fdgState;
